var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI1BusParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 29H4v25.88L12.32 57a7 7 0 1114 0H52a7 7 0 1114 0h5V42c0-3.71-1.87-10.23-8-13zM11 42H8v-9h3v9zm14 0H14v-9h11v9zm15 0H29v-9h11v9zm15 0H44v-9h11v9zm10.35 0H59v-9h3a8.731 8.731 0 012.56 2.19A11.59 11.59 0 0167 42h-1.65zm3.73-33.5a2.5 2.5 0 01-2.5 2.5H63V6h3.58a2.5 2.5 0 012.5 2.5zM55 0v22h21V0H55zm11.58 14H63v5h-3V3h6.58a5.5 5.5 0 010 11zM63 57a4 4 0 11-8 0 4 4 0 018 0zm-40.85-2.83a4 4 0 11-5.654 5.66 4 4 0 015.654-5.66z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/I1_Bus_parking.29200345.svg";
export { SvgI1BusParking as ReactComponent };